/*
 * Environment + build version helpers (porté de l'ancien Footer).
 * L'environnement est déduit du hostname ; la version est le hash git court
 * injecté au build (VITE_GIT_COMMIT_HASH).
 */
export function getEnvironment() {
  const h = (typeof window !== 'undefined' && window.location.hostname) || ''
  if (h === 'localhost' || h === '127.0.0.1' || h === '') return 'local'
  if (h.includes('preprod')) return 'preprod'
  if (h.includes('staging') || h.includes('dev')) return 'staging'
  return 'production'
}

export const isProduction = () => getEnvironment() === 'production'

// Yellow-ish accent per non-prod environment (matches the old footer badge).
export const ENV_COLOR = { local: '#f5b301', staging: '#ff9800', preprod: '#9c27b0' }

const RAW_VERSION = import.meta.env.VITE_GIT_COMMIT_HASH || 'dev'
export const APP_VERSION = RAW_VERSION === 'dev' || RAW_VERSION === 'unknown' ? 'dev' : RAW_VERSION.substring(0, 7)
export const APP_VERSION_FULL = RAW_VERSION
